
export type PaymentFieldsType = {
    label?: string,
    name?: string,
    span?: number,
    noSelectable?:boolean
    maxlength?: number
}

export const PAYMENT_FIELDS:Array<PaymentFieldsType> = [
    { label: 'American Express', name: 'amex', span: 6 },
    { label: 'Diners Club', name: 'dinersclub', span: 6 },
    { label: 'Discover Card', name: 'discovery', span: 6 },
    { span: 5 },
    { label: 'JCB', name: 'jcb', span: 6 },
    { label: 'MasterCard', name: 'mastercard', span: 6 },
    { label: 'Visa', name: 'visa', span: 6 },
    { span: 5 },
    { label: 'Corporate Meeting Card', name: 'corporatemeetingcard', span: 6 },
    { label: 'Funds Held On Credit Card', name: 'fundsheld', span: 6 },
    { label: 'Advanced Deposit Required', name: 'advanceddepositrequired', span: 6 },
    { span: 5 },
    { label: 'Is There a Max Amount Group can charge on Credit Card', name: 'ismaxamount', span: 6 },
    { label: 'If so, what is the Maximum Amount', name: 'maxamount', span: 6, noSelectable:true },
    { span: 10 },
    { label: 'Direct Bill', name: 'isDirectBill', span: 6 },
    { label: 'Direct Bill Payment Terms', name: 'directBillPaymentTerms', span: 6, noSelectable:true, maxlength: 50 },
    { span: 10 },
    { label: 'Minimum Spend to Direct Bill', name: 'isMinimumSpendToDirectBill', span: 6 },
    { label: 'If so, what is the amount (USD)', name: 'minimumSpendToDirectBillAmount', span: 6, noSelectable:true },
    { span: 10 },
    { label: 'Maximum Spend to Direct Bill', name: 'isMaximumSpendToDirectBill', span: 6 },
    { label: 'If so, what is the amount (USD)', name: 'maximumSpendToDirectBillAmount', span: 6, noSelectable:true },
    { span: 10 },
]

export const PAYMENT_OPTIONS = ['Yes','No']
export const PAYMENT_OPTIONS_NA = ['N/A', 'Yes','No']
